import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

export interface UsersCountQuery {
  group_by?: string;
}

const getUsersCount = async (queryParams?: UsersCountQuery) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<Record<string, number>>(
    "get",
    `users/analytics/count${query}`
  );
};

export const usersAnalytics = {
  getUsersCount,
};
